import { Api } from '../swaggers/swagger-docs'

/*
 * swagger 생성 클라이언트의 단일 진입점 (saas-web 의 api-client.ts 와 동일 역할).
 * 생성물의 HttpClient 는 후처리(replaceAxiosWithInstance)로 axios-instance 싱글턴을
 * 사용하므로 baseURL/인증/타임아웃은 전부 axios-instance.ts 한 곳에서 관리된다.
 *
 * 사용: apiClient.v2.apiV2ReservationElFind(params) ...
 */
export const apiClient = new Api()
